import { Weather } from "../../types/variables/Variables";

export const returnChartColor = (weather: Weather) => {
    switch (weather) {
        case Weather.SUNNY:
            return ["rgb(255, 191, 0)", "rgb(224, 62, 76)"]; // Warm gradient 🌞

        case Weather.RAINY:
            return ["rgb(173, 216, 230)", "rgb(25, 25, 112)"]; // Cool rain gradient 🌧️

        case Weather.PARTLY_RAINY:
            return ["rgb(135, 206, 235)", "rgb(100, 149, 237)"]; // Light blue with deeper blue 🌦️

        case Weather.WINDY:
            return ["rgb(176, 224, 230)", "rgb(119, 136, 153)"]; // Light cyan with gray 💨

        case Weather.FOGGY:
            return ["rgb(211, 211, 211)", "rgb(169, 169, 169)"]; // Light to dark gray 🌫️

        case Weather.STORMY:
            return ["rgb(105, 105, 105)", "rgb(0, 0, 0)"]; // Dark stormy look ⛈️

        case Weather.CLOUDY:
            return ["rgb(192, 192, 192)", "rgb(128, 128, 128)"]; // Different shades of gray ☁️

        case Weather.PARTLY_CLOUDY:
            return ["rgb(250, 250, 250)", "rgb(211, 211, 211)"]; // Lighter cloud transition 🌥️

        case Weather.THUNDERSTORM:
            return ["rgb(72, 61, 139)", "rgb(0, 0, 0)"]; // Deep purple with black ⚡

        default:
            return ["rgb(255, 255, 255)", "rgb(200, 200, 200)"]; // Neutral fallback
    }
};